import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { getUserDetails } from '../../../utils';
import { useEffect } from 'react';
import pusher, { pusherUnsubscribe } from '../../../utils/pusher';
import { checkIsSuperAdmin, getUserId } from '../../../utils/authUtils';
import { BACKEND_LOGOUT_ROUTE } from '../../../utils/routes';
import {
  addTopNotifications,
  setUnreadChatExists,
} from '../../store/slices/common/notificationsSlice';
import { setMessageToUserChats, setShowNewMessageAlert } from '../../store/slices/common/chatSlice';
import { getLanguageAsync } from '../../store/slices/common/commonSlice';
import { getSelectedCity } from '../../../utils/cityUtils';

function PusherInit() {
  const router = useRouter();
  const { profile_id } = router.query;
  const dispatch = useDispatch();
  const userDetails = getUserDetails();

  useEffect(() => {
    if (userDetails?.profile_id) {
      pusher(`notification.${userDetails?.profile_id}`).bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        (data) => {
          if (
            data?.notification_type === 'logoutUser' &&
            data?.user_id == getUserId()
          ) {
            window.location.replace(BACKEND_LOGOUT_ROUTE());
          } else {
            dispatch(addTopNotifications(data));
          }
        }
      );

      return () => {
        pusherUnsubscribe(`notification.${userDetails?.profile_id}`);
      };
    }
  }, []);

  useEffect(() => {
    if (userDetails?.profile_id) {
      pusher(`chats.${userDetails?.profile_id}`).bind('chats', (data) => {
        if (
          userDetails?.profile_id == data.chat.receiver_profile_id &&
          router.pathname !== '/chats'
        ) {
          dispatch(setUnreadChatExists(true));
        } else if (
          router.pathname == '/chats' &&
          profile_id == data.chat.sender_profile_id
        ) {
          dispatch(setMessageToUserChats(data?.chat));
          dispatch(setShowNewMessageAlert(true));
        }
      });

      return () => {
        pusherUnsubscribe(`chats.${userDetails?.profile_id}`);
      };
    }
  }, []);

  useEffect(() => {
    if (checkIsSuperAdmin() && router.pathname == '/chats') {
      pusher('chats.1').bind('chats', (data) => {
        if (profile_id == data.chat.sender_profile_id) {
          dispatch(setMessageToUserChats(data?.chat));
          dispatch(setShowNewMessageAlert(true))
        }
      });
      return () => {
        pusherUnsubscribe('chats.1');
      };
    }
  }, []);

  useEffect(() => {
    pusher('translation-channel').bind('translation-updated', (data) => {
      if (data.status === 'translation_update') {
        dispatch(getLanguageAsync({ city_id: getSelectedCity()?.id })).then(
          (res) => {
            if (res?.meta?.requestStatus === 'fulfilled') {
              localStorage.setItem('language', JSON.stringify(res?.payload));
            }
          }
        );
      }
    });

    return () => {
      pusherUnsubscribe('translation-channel');
    };
  }, []);

  return null;
}

export default PusherInit;
